import React, { useMemo, useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import CustomFormGroup from '../../../../../../components/CustomFormGroup/CustomFormGroup';
import CustomRadioGroup from '../../../../../../components/CustomRadioGroup/CustomRadioGroup';

const AmountOfAccommodation = ({ register, errors, data, clearErrors, setValue, control }) => {
  const { t } = useTranslation();
  const [sValue, setSValue] = useState();
  const stateValues = useMemo(
    () => [
      {
        label: t('yes'),
        checked: sValue === true,
        value: true,
      },
      {
        label: t('no'),
        checked: sValue === false,
        value: false,
      },
    ],
    [sValue]
  );

  return (
    <>
      <Row className="mb-3">
        <h5 className="mb-3 m-0">{t('examinations:regdExam.amountOfAccommodation.title')}</h5>
        <CustomRadioGroup
          label={t('examinations:regdExam.isPerformed')}
          labelClass="d-block"
          items={stateValues}
          controlProps={{
            name: 'amountOfAccommodationState',
            control,
            defaultValue: data?.amountOfAccommodationState,
          }}
          onChange={v => {
            clearErrors('amountOfAccommodationState');
            setSValue(v);
            setValue('amountOfAccommodationState', v);
          }}
        />
      </Row>
      <Row className="mb-3">
        <Col md={6}>
          <CustomFormGroup
            register={{ ...register('amountOfAccommodation.relativePositiveAccommodation') }}
            label={t('examinations:regdExam.amountOfAccommodation.relativePositiveAccommodation')}
            error={errors.amountOfAccommodation?.relativePositiveAccommodation}
            groupProps={{ className: 'mb-3' }}
            fixedLabel={true}
            controlProps={{
              id: 'amountOfAccommodation.relativePositiveAccommodation',
              name: 'amountOfAccommodation.relativePositiveAccommodation',
              defaultValue: data?.amountOfAccommodation?.relativePositiveAccommodation || '',
            }}
          />
        </Col>
        <Col md={6}>
          <CustomFormGroup
            register={{ ...register('amountOfAccommodation.relativeNegativeAccommodation') }}
            label={t('examinations:regdExam.amountOfAccommodation.relativeNegativeAccommodation')}
            error={errors.amountOfAccommodation?.relativeNegativeAccommodation}
            groupProps={{ className: 'mb-3' }}
            fixedLabel={true}
            controlProps={{
              id: 'amountOfAccommodation.relativeNegativeAccommodation',
              name: 'amountOfAccommodation.relativeNegativeAccommodation',
              defaultValue: data?.amountOfAccommodation?.relativeNegativeAccommodation || '',
            }}
          />
        </Col>
      </Row>
    </>
  );
};
export default AmountOfAccommodation;
